/*
WARNING
- We have three different bundles, only one is built with webpack and supports environment variables.
- This file gets string replaced at build time, which is a temporary solution until we can use webpack (or a similar bundler) for all bundles
*/

export const websdkVersion =
  (typeof process !== 'undefined' && process.env.SM_WEBSDK_VERSION) ||
  'unknown';
